import React from "react";
import { Text } from "@networkraildigitalfactory/components";
import { format } from "date-fns";
import { Check } from "phosphor-react";
import styles from "./Admin.module.css";
import ConfirmEmployee from "./ConfirmEmployee";
import useUser from "../../hooks/useUser";

const EmployeeSearchResult = (props) => {
  const { result, selectedEmployee, setSelectedEmployee, setExport } = props;

  const {
    fullName,
    email,
    jobTitle,
    empNo,
    lineManager,
    additionalLM,
    lastExportedBy,
    lastExportedOn,
    centralFunction,
  } = result;

  const successResults = [
    `Email address: ${email}`,
    `Job title: ${jobTitle}`,
    `Function: ${!centralFunction ? "No option selected" : centralFunction}`,
    `Employee number: ${empNo}`,
    `Line manager's email address: ${lineManager}`,
    `Additional line manager's email address: ${!additionalLM ? "N/A" : additionalLM}`,
    `Last exported by: ${!lastExportedBy ? "N/A" : lastExportedBy}`,
    `Last exported on: ${
      !lastExportedOn ? "N/A" : format(new Date(lastExportedOn), "dd/MM/yyyy - HH.mm")
    }`,
  ];

  const { isGBR } = useUser(email);
  const isSelectedEmployee = selectedEmployee && result.email === selectedEmployee.email;

  const confirmEmployee = () => {
    setSelectedEmployee(result);
    setExport(true);
  };

  return (
    <>
      <div
        className={
          isSelectedEmployee
            ? `${styles.searchResults} ${styles.selected}`
            : `${styles.searchResults}`
        }
      >
        <div className={styles.header_row}>
          {isGBR ? (
            <div className={`${styles.org_tag} ${styles.gbr_tag}`}>GBRTT</div>
          ) : (
            <div className={`${styles.org_tag} ${styles.nr_tag}`}>Network Rail </div>
          )}

          {isSelectedEmployee && (
            <div className={styles.selected_label}>
              Selected{" "}
              <div className={styles.circle}>
                <Check color="#ffffff" size={14} weight="bold" className={styles.check} />
              </div>
            </div>
          )}
        </div>
        <Text wrapper="h2" type="subtitle" color="#37519D">
          {fullName}
        </Text>
        {successResults.map((text) => {
          const splitMessage = text.split(":");
          return (
            <Text
              style={{
                color: "#37519D",
                fontSize: "18px",
              }}
              key={text}
            >
              <span className={styles.content_bold}>{splitMessage[0]}: </span>
              {splitMessage[1]}
            </Text>
          );
        })}
        <ConfirmEmployee showEmpMenu={confirmEmployee} />
      </div>
    </>
  );
};

export default EmployeeSearchResult;
